module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.fc8314e9.webp";